import React, { Component } from "react";
import moment from 'moment'
import axios from 'axios';

import { serverUrl , headerRequest, categoriesFilter } from '../../lib/funApp/general'
import '../categories/categories.css'

import { MDBIcon } from 'mdbreact';
import { Row, Col, Modal, Card } from 'react-bootstrap';
import { Button, Message, Icon, Popup, Label, Table, Input, Dropdown } from 'semantic-ui-react'
import { Grid, FormControl, InputLabel, Select, MenuItem, TextField } from "@material-ui/core";
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';

import CurrencyFormat from 'react-currency-format';
import { reactLocalStorage } from 'reactjs-localstorage';
import { toast } from 'react-toastify';

import Loading from '../../containers/loading';

export default class RecordDelete extends Component{

  constructor(props){
    super()
    this.categories = []
    this.state = {
        show: false,
        showEdit: false,
        showEditCat: false,
        loading: false,
        loadingEdit: false,
        dataAccount: [],
        dataPeople: [],
        editDate: '',
        editDueDate: null,
        editAccount: '',
        editPerson: '',
        editNumber: '',
        editHistory: '',
        editValue: '',
        editType: '',
        editCategories: [],
        editActiveStep: 0,
        editChecked: true,
        editTpCat: 'S',
        editTotal: 0,
        editExpenses: [],
        editIncomes: [],
    }
  }

  componentDidMount() {
    // Categories
    const targetUrlCategory = serverUrl + '/src/categories'
    axios.get(targetUrlCategory, {"headers" : headerRequest})
        .then(res => {
            if(res.status === 200){
                this.categories = res.data.items
                this.setState({
                  editExpenses: categoriesFilter({categories: res.data.items},'D'),
                  editIncomes: categoriesFilter({categories: res.data.items},'R')
                })
            }
        }).catch(error => {
            console.log(error.response)
    });

    const targetUrlAccounts = serverUrl + '/src/accounts'
    axios.get(targetUrlAccounts, {"headers" : headerRequest})
        .then(res => {
            if(res.status === 200){
                this.setState({ dataAccount: res.data.items || [] })
            }
        }).catch(error => {
            console.log(error.response)
    });

    const targetUrlPeople = serverUrl + '/src/peoples'
    axios.get(targetUrlPeople, {"headers" : headerRequest})
        .then(res => {
            if(res.status === 200){
                this.setState({ dataPeople: res.data.items || [] })
            }
        }).catch(error => {
            console.log(error.response)
    });
  }

  handleSubmit = () => {
    this.setState({loading: true});

    let targetUrl = serverUrl + '/src/records/'+ this.props.item._id
    let counterpart;
    let targetUrlT;

    if(this.props.item.type === 'T' && this.props.item.counterpart !== undefined){
      counterpart = this.props.item.counterpart._id
      targetUrlT  = serverUrl + '/src/records/'+ this.props.item.counterpart._id
    }

    axios.delete(targetUrl, {"headers" : headerRequest})
      .then(res => {
        console.log('res.status',res.status)
        if(res.status === 204){

          if(counterpart){
            axios.delete(targetUrlT, {"headers" : headerRequest})
              .then(res => {
                console.log('res.status',res.status)
                if(res.status === 204){
                  reactLocalStorage.set('@result', 204);
                  window.location.reload(true);
                }

              }).catch(error => {
                this.setState({ show: true, loading: false })
                toast.error('Erro Inesperado!!');
                console.log('ERROR: ', error.response.status + ' [' + error.response.data.message +']');
                }
              );

          }else{
            reactLocalStorage.set('@result', 204);
            window.location.reload(true);
          }
        }
      }).catch(error => {
        this.setState({ show: true, loading: false })
        toast.error('Erro Inesperado!!');
        console.log('ERROR: ', error.response.status + ' [' + error.response.data.message +']');
        }
      );
  }

  handleShowSave = () => {this.setState( prevState => { return{ show: !prevState.show }})};
  handleShowEdit = () => {
    const item = this.props.item || {}
    const sourceCategories = Array.isArray(item.category) ? item.category : []
    let editCategories = sourceCategories.map((cat, index) => ({
      id: cat && cat.category && cat.category._id ? cat.category._id : cat.category || '',
      name: cat && cat.category && cat.category.name ? cat.category.name : this.getCategory(cat && cat.category && cat.category._id ? cat.category._id : cat.category) || '',
      history: cat && typeof cat.history !== 'undefined' ? cat.history : '',
      value: Number(cat && typeof cat.value !== 'undefined' ? cat.value : 0),
    }))
    if ((item.type === 'D' || item.type === 'R') && editCategories.length === 0) {
      editCategories = [{
        id: '',
        name: '',
        history: item.history || '',
        value: Math.abs(Number(item.value || 0)),
      }]
    }
    const editTotal = editCategories.reduce((sum, cat) => sum + Number(cat.value || 0), 0)
    this.setState(prevState => ({
      showEdit: !prevState.showEdit,
      showEditCat: false,
      editDate: item.date ? new Date(item.date) : moment().toDate(),
      editDueDate: item.dueDate ? new Date(item.dueDate) : null,
      editAccount: item.account && item.account._id ? item.account._id : item.account || '',
      editPerson: item.person && item.person._id ? item.person._id : item.person || '',
      editNumber: item.number || '',
      editHistory: item.history || '',
      editValue: Math.abs(Number(item.value || 0)),
      editType: item.type || '',
      editCategories,
      editTotal,
      editActiveStep: 0,
      editChecked: true,
      editTpCat: editCategories.length > 1 ? 'M' : 'S',
    }))
  };

  changeEditField = (field, value) => {
    if (field === 'editValue' && this.state.editCategories.length === 1) {
      const next = [...this.state.editCategories]
      next[0] = { ...next[0], value: Number(value || 0) }
      this.setState({ [field]: value, editCategories: next })
      return
    }
    this.setState({ [field]: value })
  }

  handleShowEditCat = () => {
    this.setState((prevState) => ({
      showEditCat: !prevState.showEditCat,
      editActiveStep: 0,
      editChecked: true,
    }))
  }

  changeEditCategoryField = (index, field, value) => {
    const next = [...this.state.editCategories]
    if (!next[index]) return
    next[index] = { ...next[index], [field]: field === 'value' ? Number(value || 0) : value }
    const patch = { editCategories: next }
    if (next.length === 1 && field === 'value') {
      patch.editValue = Number(value || 0)
    }
    this.setState(patch)
  }

  handleEditBack = () => {
    this.setState((prevState) => ({ editActiveStep: prevState.editActiveStep - 1, editChecked: !prevState.editChecked }))
  }

  handleEditNext = () => {
    this.setState((prevState) => ({ editActiveStep: prevState.editActiveStep + 1, editChecked: !prevState.editChecked }))
  }

  changeEditTpCat = (value) => {
    if(value === 'S'){
      this.setState({ editCategories: [], editTotal: 0 })
    }
    this.setState({ editTpCat: value })
  }

  changeEditCategory = (id, name) => {
    const found = this.state.editCategories.find(element => element.id === id)
    if(found === undefined){
      const next = [...this.state.editCategories, { id: id, name: name, history: '', value: 0 }]
      this.setState({ editCategories: next }, () => this.totalEditValueCat(this.state.editCategories))
    }else{
      const next = this.state.editCategories.filter((obj) => obj.id !== id)
      this.setState({ editCategories: next }, () => this.totalEditValueCat(this.state.editCategories))
    }

    if(this.state.editTpCat === 'S'){
      this.handleShowEditCat()
    }
  }

  showEditCategories = (item, index) => {
    const found = this.state.editCategories.find(element => element.id === item.id)
    const display = found === undefined ? {display: 'none'} : {display: 'contents'}
    const color = this.getTypeMeta().color

    let comp =  <li className='mb-2' style={{cursor: 'pointer'}} key={index}>
                  <Label color={found === undefined ? color : 'green'} basic pointing='left' disabled={true} onClick={e => this.changeEditCategory(item.id, item.name)}>
                    <span id='labelInterna'>{item.name}</span>
                  </Label>
                    <i data-test="fa" className="far fa-check-circle text-success" id={'editCatCheck'+item.id} name='editCatCheck' style={display}></i>
                </li>

    if(item.child && item.child.length > 0){
      let childs =
        <ul className='tree' key={`editUl${index}`}>
          {item.child.map((childItem, childIndex)=>(
            this.showEditCategories(childItem, childIndex)
          ))}
        </ul>
      return [comp, childs]
    }
    return comp
  }

  totalEditValueCat = (newArr) => {
    let total = 0
    newArr.forEach((item) => {
      total = total + Number(item.value || 0)
    })
    this.setState({editTotal: total})
  }

  updateEditFieldChanged = (index, event)=> {
    if(event.name === 'valueCat'){
      if(event.value >= 0){
        let newArr = [...this.state.editCategories]
        newArr[index]['value'] = parseFloat(event.value)
        this.setState({ editCategories: newArr })
        this.totalEditValueCat(newArr)
      }
    }else{
      let newArr = [...this.state.editCategories]
      newArr[index]['history'] = (event.value || '').trim()
      this.setState({ editCategories: newArr })
    }
  }

  saveEditCat = () => {
    this.setState((prevState)=>({editValue: prevState.editTotal}))
    this.handleShowEditCat()
  }

  addEditCategoryRow = () => {
    const next = [...this.state.editCategories]
    next.push({
      id: '',
      name: '',
      history: '',
      value: 0,
    })
    this.setState({ editCategories: next }, () => this.totalEditValueCat(this.state.editCategories))
  }

  removeEditCategoryRow = (index) => {
    const next = this.state.editCategories.filter((_, i) => i !== index)
    this.setState({ editCategories: next }, () => this.totalEditValueCat(this.state.editCategories))
  }

  handleSubmitEdit = async () => {
    const item = this.props.item
    if (!item || !item._id) return

    this.setState({ loadingEdit: true })

    try {
      const isTransfer = item.type === 'T'
      const payload = {
        date: this.state.editDate ? new Date(this.state.editDate) : item.date,
        history: this.state.editHistory,
        number: this.state.editNumber,
      }

      if (item.prevision && this.state.editDueDate && moment(this.state.editDueDate).isValid()) {
        payload.dueDate = new Date(this.state.editDueDate)
      }

      if (!isTransfer) {
        const sign = item.type === 'D' ? -1 : 1
        if (!this.state.editAccount) {
          toast.error('Selecione a conta.')
          this.setState({ loadingEdit: false })
          return
        }
        payload.account = this.state.editAccount
        payload.type = item.type
        payload.person = this.state.editPerson || undefined

        const categoriesDraft = this.state.editCategories || []
        const hasEmptyCategoryRow = categoriesDraft.some((cat) => !cat || !cat.id)
        if (categoriesDraft.length > 0 && hasEmptyCategoryRow) {
          toast.error('Existe categoria sem seleção. Preencha ou remova a linha.')
          this.setState({ loadingEdit: false })
          return
        }

        const sourceCategories = categoriesDraft
          .filter((cat) => cat && cat.id)
          .map((cat, index) => ({
            order: index + 1,
            category: cat.id,
            history: cat.history || '',
            value: Number(cat.value || 0),
          }))

        if (sourceCategories.length > 1) {
          const categoriesTotal = sourceCategories.reduce(
            (sum, cat) => sum + Number(cat.value || 0),
            0
          )
          if (categoriesTotal === 0) {
            toast.error('A soma das categorias não pode ser zero.')
            this.setState({ loadingEdit: false })
            return
          }
          payload.category = sourceCategories
          payload.value = categoriesTotal * sign
        } else if (sourceCategories.length === 1) {
          const cat = sourceCategories[0]
          const baseValue = Number(this.state.editValue || 0)
          if (baseValue === 0) {
            toast.error('O valor não pode ser zero.')
            this.setState({ loadingEdit: false })
            return
          }
          payload.category = [{
            order: 1,
            category: cat.category,
            history: cat.history || this.state.editHistory || '',
            value: baseValue,
          }]
          payload.value = baseValue * sign
        } else {
          const baseValue = Number(this.state.editValue || 0)
          if (baseValue === 0) {
            toast.error('O valor não pode ser zero.')
            this.setState({ loadingEdit: false })
            return
          }
          payload.value = baseValue * sign
        }
      }

      await axios.patch(serverUrl + '/src/records/' + item._id, payload, {"headers" : headerRequest})

      if (isTransfer && item.counterpart && item.counterpart._id) {
        const counterpartPayload = {
          date: payload.date,
          history: payload.history,
          number: payload.number,
        }
        await axios.patch(serverUrl + '/src/records/' + item.counterpart._id, counterpartPayload, {"headers" : headerRequest})
      }

      reactLocalStorage.set('@result', 200);
      window.location.reload(true);
    } catch (error) {
      toast.error('Erro ao editar lançamento!')
      console.log(error.response || error)
      this.setState({ loadingEdit: false })
    }
  }

  getCategory = (id) => {
    const found = this.categories.find(element => element._id === id);
    if(found !== undefined){
        return found.name
    }
  }

  getTypeMeta = () => {
    const type = this.state.editType
    if (type === 'D') return { color: 'red', icon: 'minus-square', label: 'Despesa' }
    if (type === 'R') return { color: 'blue', icon: 'plus-square', label: 'Receita' }
    if (type === 'T') return { color: 'green', icon: 'random', label: 'Transferência' }
    return { color: 'grey', icon: 'edit', label: 'Lançamento' }
  }

  getCategoriesForEditType = () => {
    if (this.state.editType === 'D') return this.categories.filter(item => item.type === 'D')
    if (this.state.editType === 'R') return this.categories.filter(item => item.type === 'R')
    return this.categories
  }

  getEditCategoryLabel = () => {
    const list = this.state.editCategories || []
    if (this.state.editTpCat === 'M' && list.length > 1) {
      return 'Diversas'
    }
    if (list.length === 1 && list[0].id) {
      return list[0].name || this.getCategory(list[0].id) || 'Categoria selecionada'
    }
    return 'Escolha a Categoria...'
  }

  render(){
    return(
        <>
          <Button.Group>
            <Popup content='Editar o Lançamento' style={{color: 'orange'}} trigger={
              <Button color='orange' onClick={this.handleShowEdit}><MDBIcon icon="pencil-alt" title='Editar'/></Button>
            } />
            <Button.Or text='ou' />
            <Popup content='Apagar o Lançamento' style={{color: 'red'}} trigger={
              <Button color='red' onClick={this.handleShowSave}><MDBIcon icon="trash-alt"  title='Apagar'/></Button>
            } />
          </Button.Group>
          <Modal show={this.state.show} onHide={e=>this.handleShowSave()} centered>
            <Modal.Header closeButton>
              <Modal.Title className='red-text'><MDBIcon icon="trash-alt" className="mr-2" />
                Excluir Registro
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Row>
                <Col><div id="return" className="w-100 font-weight-bold text-wrap"></div></Col>
              </Row>
              <Row className="justify-content-center">
                <Col>
                  <Message icon style={{marginBottom: '0px'}}>
                    <Icon name='cog' loading className='red-text' />
                    <Message.Content>
                      <Message.Header>Deseja Excluir o Registro?</Message.Header>
                    </Message.Content>
                  </Message>
                  <Card>
                    <Card.Body>
                      <Grid
                        container
                        spacing={3}
                        direction="row"
                        justify="center"
                        alignItems="center"
                      >
                        <Grid item xs={12} md={6}>
                          <strong>Data:</strong> {moment(this.props.item.date).format('DD/MM/YYYY')}
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <strong>Valor:</strong>
                          <CurrencyFormat
                            value={this.props.item.value}
                            displayType={'text'}
                            thousandSeparator="."
                            decimalSeparator=","
                            fixedDecimalScale={true}
                            decimalScale={2}
                            className="ml-3 float-right"
                            prefix="R$ "
                          />
                        </Grid>
                      </Grid>
                      {this.props.item.person !== undefined ?
                        <Grid item xs={12} className='mt-3'>
                            <strong>Pessoa:</strong> { this.props.item.person.name }
                        </Grid>
                      : false
                      }
                      {this.props.item.history !== undefined ?
                        <Grid item xs={12} className='mt-3'>
                            <strong>Histórico:</strong> {this.props.item.history}
                        </Grid>
                      : false
                      }
                      <Grid item md={12} className='mt-3'>
                          <strong>Conta
                            {this.props.item.value < 0 ? ' (Saída): ':' (Entrada): '}
                          </strong> {this.props.item.account.name}
                      </Grid>
                      {this.props.item.type === 'T' ?
                        this.props.item.counterpart !== undefined ?
                        <Grid item md={12} className='mt-3'>
                          <strong>Contra Partida
                            {this.props.item.counterpart.value < 0 ? ' (Saída): ':'  (Entrada):'}
                          </strong> {this.props.item.counterpart.account.name}
                        </Grid>
                        : false :
                        <Grid item md={12} className='mt-3'>
                            <strong>Categoria: </strong>
                            {this.props.item.category.length > 1 ? 'Diversas' : this.props.item.category[0].category !== undefined ? this.getCategory(this.props.item.category[0].category) : ''}
                        </Grid>
                      }
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
              </Modal.Body>
              <Modal.Footer>
                <Row className="justify-content-md-center">
                  <Col>
                    <Button.Group>
                      <Button negative onClick={this.handleShowSave} >
                        <strong style={{fontWeight: '700'}} >Cancelar</strong>
                      </Button>
                      <Button.Or text='ou' size='large'/>
                      <Button positive onClick={this.handleSubmit}>
                        <strong style={{fontWeight: '700'}} >Excluir</strong>
                      </Button>
                    </Button.Group>
                  </Col>
                </Row>
              </Modal.Footer>
          </Modal>
          <Modal
            show={this.state.showEdit}
            onHide={this.handleShowEdit}
            centered
            size="lg"
            enforceFocus={false}
            restoreFocus={false}
            backdrop={this.state.showEditCat ? false : true}
            style={this.state.showEditCat ? { zIndex: 1040 } : undefined}
          >
            <Modal.Header style={{padding: '5px'}}>
              <Button.Group color={this.getTypeMeta().color} style={{width: '100%'}}>
                <Button fluid icon labelPosition='left' color={this.getTypeMeta().color}>
                  <MDBIcon icon={this.getTypeMeta().icon} className='mr-2'/>
                  Editar {this.getTypeMeta().label}
                </Button>
              </Button.Group>
            </Modal.Header>
            <Modal.Body style={{padding: '7px'}}>
              <Card>
                <Card.Body>
                  <Grid container spacing={3} direction="row" justify="center" alignItems="center">
                    <Grid item xs={12} style={{ display: 'flex', gap: '24px', flexWrap: 'wrap' }}>
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                          margin="normal"
                          id="date-picker-edit"
                          label="Data"
                          value={this.state.editDate}
                          onChange={e => this.changeEditField('editDate', e)}
                          format="dd/MM/yyyy"
                          KeyboardButtonProps={{ 'aria-label': 'Alterar Data' }}
                          style={{marginTop:"0px", width: "150px"}}
                        />
                      </MuiPickersUtilsProvider>
                      {this.props.item && this.props.item.prevision ? (
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                          <KeyboardDatePicker
                            margin="normal"
                            id="date-picker-edit-due"
                            label="Vencimento"
                            value={this.state.editDueDate}
                            onChange={e => this.changeEditField('editDueDate', e)}
                            format="dd/MM/yyyy"
                            KeyboardButtonProps={{ 'aria-label': 'Alterar Vencimento' }}
                            style={{marginTop:"0px", width: "150px"}}
                          />
                        </MuiPickersUtilsProvider>
                      ) : false}
                    </Grid>

                    {this.props.item && this.props.item.type !== 'T' ? (
                      <>
                        <Grid item xs={12} md={6}>
                          <FormControl className={"col-12"}>
                            <InputLabel id="edit-person-label">Pessoa</InputLabel>
                            <Select
                              labelId="edit-person-label"
                              value={this.state.editPerson}
                              onChange={e => this.changeEditField('editPerson', e.target.value)}
                              className={"col-12"}
                            >
                              <MenuItem value="">Sem pessoa</MenuItem>
                              {this.state.dataPeople.map((person) => (
                                <MenuItem key={person._id} value={person._id}>{person.name}</MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <FormControl className={"col-12"}>
                            <InputLabel id="edit-account-label">Conta</InputLabel>
                            <Select
                              labelId="edit-account-label"
                              value={this.state.editAccount}
                              onChange={e => this.changeEditField('editAccount', e.target.value)}
                              className={"col-12"}
                            >
                              {this.state.dataAccount.map((acc) => (
                                <MenuItem key={acc._id} value={acc._id}>{acc.name}</MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <TextField
                            type="text"
                            value={this.state.editNumber}
                            label="Número"
                            className={"col-12"}
                            onChange={e => this.changeEditField('editNumber', e.target.value)}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <TextField
                            type="number"
                            value={this.state.editValue}
                            label="Valor"
                            className={"col-12"}
                            onChange={e => this.changeEditField('editValue', e.target.value)}
                            disabled={this.state.editCategories.length > 1}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <TextField
                            type="text"
                            value={this.state.editHistory}
                            label="Histórico"
                            className={"col-12"}
                            onChange={e => this.changeEditField('editHistory', e.target.value)}
                          />
                        </Grid>

                        <Grid item xs={12}>
                          <Button as='div' labelPosition='right' onClick={this.handleShowEditCat}>
                            <Button primary color={this.getTypeMeta().color} id='BtnCatEdit'>
                              <Icon name='sitemap' />
                            </Button>
                            <Label as='a' basic pointing='left' color={this.getTypeMeta().color}>
                              {this.getEditCategoryLabel()}
                            </Label>
                          </Button>
                        </Grid>
                      </>
                    ) : (
                      <>
                        <Grid item xs={12} md={6}>
                          <TextField
                            type="text"
                            value={this.state.editNumber}
                            label="Número"
                            className={"col-12"}
                            onChange={e => this.changeEditField('editNumber', e.target.value)}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <TextField
                            type="text"
                            value={this.state.editHistory}
                            label="Histórico"
                            className={"col-12"}
                            onChange={e => this.changeEditField('editHistory', e.target.value)}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <Message icon size='small'>
                            <Icon name='info circle' />
                            <Message.Content>
                              Em transferências, edição altera data, histórico e número para manter a consistência.
                            </Message.Content>
                          </Message>
                        </Grid>
                      </>
                    )}
                  </Grid>
                </Card.Body>
              </Card>
            </Modal.Body>
            <Modal.Footer>
              <Row className="justify-content-end w-100">
                <Col className="col-auto">
                  <Button.Group>
                    <Button negative onClick={this.handleShowEdit}>
                      <strong style={{fontWeight: '700'}} >Cancelar</strong>
                    </Button>
                    <Button.Or text='ou' size='large'/>
                    <Button positive onClick={this.handleSubmitEdit} loading={this.state.loadingEdit}>
                      <strong style={{fontWeight: '700'}} >Salvar</strong>
                    </Button>
                  </Button.Group>
                </Col>
              </Row>
            </Modal.Footer>
          </Modal>
          <Modal show={this.state.showEditCat} onHide={this.handleShowEditCat} centered size='md' style={{ zIndex: 2000 }}>
              <Modal.Header closeButton>
                <div style={{width: '100%'}}>
                  {this.state.editChecked ?
                    <Dropdown text={this.state.editTpCat === 'S' ? 'Simples' : 'Multiplo'} simple item className='mr-2 float-right' style={{fontSize: 'large'}}>
                      <Dropdown.Menu>
                        <Dropdown.Item text='Simples' onClick={e => this.changeEditTpCat('S')} />
                        <Dropdown.Item text='Multiplo' onClick={e => this.changeEditTpCat('M')} />
                      </Dropdown.Menu>
                    </Dropdown>
                  : <div className="float-right">Valores</div>}
                </div>
              </Modal.Header>
              <Modal.Body>
                <div style={{display: 'flex'}}>
                  {this.state.editActiveStep === 0 ?
                    <div style={{width: '100%'}}>
                      {this.state.editType === 'D' ?
                        <div className="mb-2 text-danger">
                          <MDBIcon icon="plane-arrival" size="lg"/> <strong>Despesas</strong>
                        </div>
                      :
                        <div className="mb-2 text-primary">
                          <MDBIcon icon="plane-departure" size="lg"/> <strong>Receitas</strong>
                        </div>
                      }
                      {this.state.editType === 'D' ?
                        <div className="cltDanger">
                          <ul className='tree'>
                            {this.state.editExpenses.length > 0 ?
                              this.state.editExpenses.map((item, i1)=>(
                                this.showEditCategories(item,i1)
                              ))
                              : false}
                          </ul>
                        </div>
                      :
                        <div className="cltPrimary">
                          <ul className='tree'>
                            {this.state.editIncomes.length > 0 ?
                              this.state.editIncomes.map((item, i1)=>(
                                this.showEditCategories(item,i1)
                              ))
                              : false}
                          </ul>
                        </div>
                      }
                    </div>
                  :
                    <div style={{width: '100%'}}>
                      <Button as='div' labelPosition='right' style={{width: '100%'}}>
                        <Button basic color='blue'>
                          <Icon name='fork' />
                          <CurrencyFormat
                            value={this.state.editValue}
                            displayType={'text'}
                            thousandSeparator="."
                            decimalSeparator=","
                            fixedDecimalScale={true}
                            decimalScale={2}
                            className="float-right"
                            prefix="Valor: "
                          />
                        </Button>
                        <Label as='a' basic
                          color={
                            this.state.editTotal < this.state.editValue ? 'red': this.state.editTotal > this.state.editValue ? 'green': 'blue'
                          } pointing='left'>
                          <CurrencyFormat
                            value={this.state.editTotal}
                            displayType={'text'}
                            thousandSeparator="."
                            decimalSeparator=","
                            fixedDecimalScale={true}
                            decimalScale={2}
                            className="float-right"
                            prefix="Total: "
                          />
                        </Label>
                      </Button>
                      <Table basic='very' celled style={{width: '100%'}}>
                        <Table.Header>
                          <Table.Row>
                            <Table.HeaderCell>#</Table.HeaderCell>
                            <Table.HeaderCell>Categoria</Table.HeaderCell>
                            <Table.HeaderCell>Histórico</Table.HeaderCell>
                            <Table.HeaderCell>Valor</Table.HeaderCell>
                          </Table.Row>
                        </Table.Header>
                        <Table.Body>
                          {this.state.editCategories.map((item, index)=>(
                            <Table.Row key={index}>
                              <Table.Cell>{index+1}</Table.Cell>
                              <Table.Cell>{item.name}</Table.Cell>
                              <Table.Cell>
                                <Input
                                  name='historyCat'
                                  value={item.history}
                                  onChange={e => this.updateEditFieldChanged(index, {name: 'historyCat', value: e.target.value})}
                                  fluid
                                />
                              </Table.Cell>
                              <Table.Cell>
                                <Input
                                  name='valueCat'
                                  type='number'
                                  value={item.value}
                                  onChange={e => this.updateEditFieldChanged(index, {name: 'valueCat', value: e.target.value})}
                                  fluid
                                />
                              </Table.Cell>
                            </Table.Row>
                          ))}
                        </Table.Body>
                      </Table>
                    </div>
                  }
                </div>
              </Modal.Body>
              <Modal.Footer>
                {this.state.editTpCat === 'M' ? (
                  <Button.Group>
                    {this.state.editActiveStep === 0 ? (
                      <Button negative onClick={this.handleShowEditCat}><Icon name='remove'/> Cancelar</Button>
                    ) : (
                      <Button color='blue' onClick={this.handleEditBack}><Icon name='angle double left'/> Anterior</Button>
                    )}
                    <Button.Or text='ou' />
                    {this.state.editActiveStep === 1 ? (
                      <Button positive disabled={this.state.editTotal > 0 ? false : true} onClick={this.saveEditCat}><Icon name='checkmark'/> Salvar</Button>
                    ) : (
                      <Button color='blue' disabled={this.state.editCategories.length > 1 ? false : true} onClick={this.handleEditNext}>Próximo <Icon name='angle double right'/></Button>
                    )}
                  </Button.Group>
                ) : (
                  <Button negative onClick={this.handleShowEditCat}><Icon name='remove'/> Fechar</Button>
                )}
              </Modal.Footer>
          </Modal>
            { this.state.loading ?
                <Loading />
            : false }
          </>
    )}
}
